/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Progression_Third_SetInputs */

const en_us2_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week}: a third set on everything`)
};

const pt_br2_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}: terceira série em tudo`)
};

const es_419_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}: una tercera serie en todo`)
};

const pt_pt2_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}: terceira série em tudo`)
};

const fr_fr2_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week} : une troisième série sur tout`)
};

const de_de2_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week}: überall ein dritter Satz`)
};

const it_it2_progression_third_set = /** @type {(inputs: Progression_Third_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week}: una terza serie su tutto`)
};

/**
* | output |
* | --- |
* | "Week {week}: a third set on everything" |
*
* @param {Progression_Third_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_third_set = /** @type {((inputs: Progression_Third_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Third_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_third_set(inputs)
	if (locale === "es-419") return es_419_progression_third_set(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_third_set(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_third_set(inputs)
	if (locale === "de-DE") return de_de2_progression_third_set(inputs)
	if (locale === "it-IT") return it_it2_progression_third_set(inputs)
	return en_us2_progression_third_set(inputs)
});
export { progression_third_set as "progression.third_set" }